import {twJoin} from "tailwind-merge";

// TODO: Convert this to GenericNoDataFoundComponent, and take border/rounded as props?
export function TableNoDataFoundComponent({className}: {className?: string}) {
    return (
        <div
            className={twJoin(
                "w-full h-full rounded-[0.5rem]",
                // "bg-[#ffe9e9] text-[#ff0000]",
                "border-ds-border-width border-solid border-ds-border",
                "grid grid-cols-1 grid-rows-1 place-items-center",
                className,
            )}
        >
            No data found
        </div>
    );
}
